"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  titleSearch: {
    title: 'Dangerous Cargo & Special Container Application Query',
    refNo: 'Ref No.',
    placeholderRefNo: 'Ref No.',
    validateNullRefNo: 'refNo is null'
  },
  dangerCargo: {
    result: 'Danger Cargo Result',
    refNo: 'Ref No.',
    status: 'Status',
    vvl: 'VVL',
    pol: 'POL',
    pod: 'POD',
    mix: 'Mix',
    applyPerson: 'Apply Person',
    applyDate: 'Apply Date',
    updateTime: 'Updated Time',
    CNTRQuantity: 'Quantity',
    IMOClass: 'IMO Class',
    UNNo: 'UN No.'
  },
  speContainer: {
    result: 'Special Container Result',
    refNo: 'Ref No.',
    status: 'Status',
    vesselCode: 'Vessel Code',
    voyageNo: 'Voyage No',
    voyageLeg: 'Voyage Leg',
    pol: 'POL',
    pod: 'POD',
    applyPerson: 'Apply Person',
    applyDate: 'Apply Date',
    updateTime: 'Updated Time'
  }
};